import React from 'react';
import clsx from "clsx";
import { Box, Typography, Avatar } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { grey } from '@material-ui/core/colors';
import ImageIcon from '@material-ui/icons/Image';
import Eans from './Eans/Eans';

const useStyles = makeStyles((theme) => ({
  root: {
    overflowY: "auto",
    paddingRight: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    color: grey[800],
  },
  item: {
    alignItems: "start",
    marginRight: theme.spacing(1),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    borderBottom: '1px dashed #CCC',
    color: grey[800],
  },
  pageBreakBefore: {
    pageBreakBefore: 'always',
  },
  rounded: {
    marginTop: 3,
    color: grey[400],
    backgroundColor: grey[200],
    width: 50,
    height: 50,
    border: `1px solid ${grey[200]}`
  },
  price: {
    textAlign: "right"
  },
  description: {
    //lineHeight:
  },
  priceTotal: {
    textAlign: "right",
    color: "#12cd0b",
    fontWeight: "bold"
  },
  priceValor: {
    textAlign: "right",
    fontWeight: "bold"
  },
  labelEstoque: {
    padding: '1px 8px',
    borderRadius: 6,
    color: '#FFFF',
    fontWeight: "bold",
    textAlign: "right",
  },
  green: { backgroundColor: '#12cd0b' },
  red: { backgroundColor: '#dc392c' },
  orange: { backgroundColor: '#fbc700' },
  boxEstoque: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: 12,
    marginBottom: 12
  },
  imeis: {
    fontSize: 11
  }
}));

export default function Items(props) {
  const {items, currency, subtotal, entrega, desconto, total, status} = props;
  const classes = useStyles();

  const textEstoque = (item) => {
    if ((item.estoque >= item.quantidade) || (item.estoque > 0 && item.estoque < item.quantidade)) {
      return (<Typography variant="subtitle2" className={[classes.labelEstoque, classes.green]}>Estoque estimado: {item.estoque}</Typography>)
    }
  }

  return <>
    {
      items && items.map((item, indice) => {
        const quantidadeTotal = item.quantidadeTotal != null ? item.quantidadeTotal : item.quantidade;
        return (
            <Box
                key={indice}
                display="flex"
                alignItems="center"
                p={0}
                className={clsx(classes.item, {
                  [classes.pageBreakBefore]: indice === 11 ||
                  indice === 26 || indice === 40 || indice === 54 || indice === 68 ||
                  indice === 82 || indice === 96
                })}
            >
              <Box width={60} minWidth={60}>
                <Typography variant="h6">
                  {quantidadeTotal}x
                </Typography>
              </Box>
              <Box width={66} minWidth={66}>
                <Avatar variant="rounded" className={classes.rounded} src={item.imageUrl}>
                  <ImageIcon fontSize="large"/>
                </Avatar>
              </Box>
              <Box flexGrow={1}>
                <Typography variant="subtitle2">{item.descricao}</Typography>
                <Eans eans={item.eans} codigoEAN={item.codigoEAN}/>
                <Typography variant="body2"><b>SAP:</b> {item.codigoSAP}</Typography>
                {
                  item.imeis && item.imeis.length > 0 && item.imeis.map((qtdeImei, i) => {
                    return (
                        <Typography key={item.codigoEAN + '_' + i} variant="body2" className={classes.imeis}>
                          <b>IMEI(s) do Item {(i + 1)}: </b>
                          {qtdeImei.length > 0 && qtdeImei.map((imei, j) => {
                            return imei && <span key={i + "_" + j}>
                          <span key={'imei_' + j}>{imei}</span>
                              {qtdeImei.length !== (j + 1) && <> / </>}
                        </span>
                          })
                          }
                        </Typography>
                    )
                  })
                }
              </Box>
              <Box minWidth={160}>
                <Typography variant="h6" className={classes.priceValor}>
                  {item.currency ? item.currency : 'R$'}&nbsp;
                  {item.valorTotal && item.valorTotal.toLocaleString(undefined, {minimumFractionDigits: 2})}
                </Typography>
                <Typography variant="subtitle1" className={classes.price}>
                  {quantidadeTotal}x&nbsp;
                  {item.currency ? item.currency : 'R$'}&nbsp;
                  {item.valorUnitario && item.valorUnitario.toLocaleString(undefined, {minimumFractionDigits: 2})}
                </Typography>
                {['NOVO_PEDIDO', 'EM_SEPARACAO'].includes(status) &&
                <Box className={classes.boxEstoque}>
                  {textEstoque(item)}
                </Box>
                }
              </Box>
            </Box>
        )
      })
    }
    <Box display="flex" p={0} className={classes.root}>
      <Box flexGrow={1}>
        <Box>
          <Typography variant="subtitle2">Subtotal</Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2">Desconto</Typography>
        </Box>
        <Box>
          <Typography variant="subtitle2">Entrega</Typography>
        </Box>
        <Box>
          <Typography variant="h6">Total</Typography>
        </Box>
      </Box>

      <Box minWidth={160}>
        <Box minWidth={160}>
          <Typography variant="subtitle2" className={classes.priceValor}>
            {currency ? currency : 'R$'}&nbsp;{subtotal.toLocaleString(undefined, {minimumFractionDigits: 2})}
          </Typography>
        </Box>
        <Typography variant="subtitle2" className={classes.priceValor}>
          {'- ' + (currency ? currency : 'R$')}&nbsp;{desconto.toLocaleString(undefined, {minimumFractionDigits: 2})}
        </Typography>
        <Typography variant="subtitle2" className={classes.priceValor}>
          {'+ ' + (currency ? currency : 'R$')}&nbsp;{entrega.toLocaleString(undefined, {minimumFractionDigits: 2})}
        </Typography>
        <Typography variant="h6" className={clsx(classes.priceValor, classes.priceTotal)}>
          {currency ? currency : 'R$'}&nbsp;{(total || 0).toLocaleString(undefined, {minimumFractionDigits: 2})}
        </Typography>
      </Box>
    </Box>
    <Box className={classes.pageBreakBefore}/>
  </>
}
